(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-script"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
 const select = event.target.closest('[data-variant-select]');
 if (!select) return;
 const section = select.closest('[data-product-section]');
 const option = select.selectedOptions[0];
 const button = section.querySelector('[data-add]');
 const quantity = section.querySelector('[data-quantity]');
 section.querySelector('[data-price]').textContent = option.dataset.price;
 button.disabled = option.dataset.available !== 'true';
 button.textContent = button.disabled ? button.dataset.sold : button.dataset.ready;
 quantity.min = option.dataset.min || '1';
 quantity.step = option.dataset.step || '1';
 if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
 quantity.value = quantity.min;
 const url = new URL(location.href);url.searchParams.set('variant', select.value);history.replaceState({}, '', url);
});
function initCountries(){document.querySelectorAll('[data-country-select]').forEach(select=>{if(select.dataset.selected)select.value=select.dataset.selected;});}
initCountries();document.addEventListener('shopify:section:load',initCountries);
document.addEventListener('submit',event=>{if(event.target.matches('[data-delete-address]')&&!window.confirm(event.target.querySelector('button').dataset.confirm))event.preventDefault();});
  } catch(e) { console.error(e); }
})();

})();
